export function HttpPrefixDirective() {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, element, attrs, controller) {
      function ensureHttpPrefix(value) {
        // Need to add prefix if we don't have https:// prefix already AND we don't have part of it
        if (value && !/^(https?):\/\//i.test(value) && 'http://'.indexOf(value) === -1) {
          controller.$setViewValue('https://' + value);
          controller.$render();
          return 'https://' + value;
        } else {
          return value;
        }
      }
      controller.$formatters.push(ensureHttpPrefix);
      controller.$parsers.splice(0, 0, ensureHttpPrefix);
    },
  };
}

// link: function () {
